module.exports = __webpack_public_path__ + "static/media/W2.ac05d039.png";